import { render } from "./SelectionActions.vue?vue&type=template&id=3004dcfe"
import script from "./SelectionActions.vue?vue&type=script&lang=js"
export * from "./SelectionActions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SelectionActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3004dcfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3004dcfe', __exports__)) {
    api.reload('3004dcfe', __exports__)
  }
  
  module.hot.accept("./SelectionActions.vue?vue&type=template&id=3004dcfe", () => {
    api.rerender('3004dcfe', render)
  })

}


export default __exports__